'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import './Consult.scss';
import { fetchPostLawSchedule } from '@module/apis/client-side/law';
import type { FetchLawScheduleParams } from '@module/apis/client-side/law/type';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { cn } from '@module/lib/utils';
import useModalStore from '@module/stores/useModalStore';
import { BaseHttpResponseError } from '@module/utils/error/apiErrors';
import getUserAgentInfo from '@module/utils/user-agent/getUserAgentInfo';
import { Checkbox } from '@pc/components/ui/checkbox';
import { Input } from '@pc/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@pc/components/ui/select';
import { Textarea } from '@pc/components/ui/textarea';
import Cookies from 'js-cookie';
import LawCustomInput from './utils/LawCustomInput';
const phoneList = ['010', '011', '016', '017', '018', '019'].map(el => ({
  name: el,
  code: el
}));
function Consult() {
  const $ = _c(129);
  const [tab, setTab] = useState(1);
  const {
    loginInfo,
    isLogin
  } = useGetLoginInfoQuery();
  const {
    pushModal,
    popModal
  } = useModalStore();
  const [id, setId] = useState(loginInfo?.loginInfo.userInfo.nick || "");
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      fitst: "",
      second: ""
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [phone, setPhone] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      name: "010",
      code: "010"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [phoneSelect, setPhoneSelect] = useState(t1);
  const [platform, setPlatform] = useState("");
  const [description, setDescription] = useState("");
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      Personal: false,
      marketing: false
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [check, setCheck] = useState(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = Cookies.get("lawIntro");
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const partner = t3;
  let loginModalHandler;
  let submitHandler;
  let validateModal;
  if ($[4] !== company || $[5] !== description || $[6] !== name || $[7] !== phone.fitst || $[8] !== phone.second || $[9] !== phoneSelect.code || $[10] !== platform || $[11] !== popModal || $[12] !== pushModal || $[13] !== tab) {
    submitHandler = async () => {
      const params = {
        type: tab === 1 ? "user" : "enter",
        name,
        ...(!!partner && {
          partner
        }),
        ...(tab === 2 && {
          company_name: company
        }),
        platform,
        contents: description,
        phone1: phoneSelect.code,
        phone2: phone.fitst,
        phone3: phone.second
      };
      ;
      try {
        const res = await fetchPostLawSchedule(params);
        if (res.result) {
          pushModal({
            type: "CONFIRM_MODAL",
            id: "Consult",
            options: {
              description: "\uC0C1\uB2F4\uC2E0\uCCAD\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
            }
          });
        }
      } catch (t4) {
        const err = t4;
        if (err instanceof BaseHttpResponseError) {
          if (err.message === "\uC774\uBBF8 \uC2E0\uCCAD\uD55C \uC0C1\uB2F4\uC774 \uC788\uC2B5\uB2C8\uB2E4.") {
            pushModal({
              type: "CONFIRM_MODAL",
              id: "Consult",
              options: {
                description: "\uC774\uBBF8 \uC2E0\uCCAD\uD55C \uC608\uC57D\uC774\uC788\uC2B5\uB2C8\uB2E4.",
                onClose: () => {
                  initStateHandler();
                  popModal();
                }
              }
            });
          }
        }
      }
    };
    let t5;
    if ($[17] !== pushModal) {
      t5 = () => {
        pushModal({
          type: "AUTH_MODAL",
          id: "Consult"
        });
      };
      $[17] = pushModal;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    loginModalHandler = t5;
    let t6;
    if ($[19] !== pushModal) {
      t6 = description_0 => {
        pushModal({
          type: "CONFIRM_MODAL",
          id: "Consult",
          options: {
            description: description_0
          }
        });
      };
      $[19] = pushModal;
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    validateModal = t6;
    const initStateHandler = () => {
      setId("");
      setCompany("");
      setPhone({
        fitst: "",
        second: ""
      });
      setPlatform("");
      setDescription("");
      setCheck(_temp);
    };
    $[4] = company;
    $[5] = description;
    $[6] = name;
    $[7] = phone.fitst;
    $[8] = phone.second;
    $[9] = phoneSelect.code;
    $[10] = platform;
    $[11] = popModal;
    $[12] = pushModal;
    $[13] = tab;
    $[14] = loginModalHandler;
    $[15] = submitHandler;
    $[16] = validateModal;
  } else {
    loginModalHandler = $[14];
    submitHandler = $[15];
    validateModal = $[16];
  }
  let t4;
  if ($[21] !== loginInfo?.loginInfo.userInfo.nick) {
    t4 = () => {
      setId(loginInfo?.loginInfo.userInfo.nick || "");
    };
    $[21] = loginInfo?.loginInfo.userInfo.nick;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] !== loginInfo) {
    t5 = [loginInfo];
    $[23] = loginInfo;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  useEffect(t4, t5);
  let t6;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = getUserAgentInfo();
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  const {
    isMobile
  } = t6;
  const nikName = tab === 2 && !company;
  const submitDisabled = nikName || !phone.fitst || !phone.second || !platform || !description;
  const submitPersonalDisabled = !check.Personal;
  const submitMarketingDisabled = !check.marketing;
  let t7;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setTab(1);
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  const t8 = tab === 1;
  let t9;
  if ($[27] !== t8) {
    t9 = cn({
      active: t8
    });
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t9) {
    t10 = <button onClick={t7} className={t9}>개인 문의</button>;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setTab(2);
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  const t12 = tab === 2;
  let t13;
  if ($[32] !== t12) {
    t13 = cn({
      active: t12
    });
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t13) {
    t14 = <button onClick={t11} className={t13}>엔터 문의</button>;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t10 || $[37] !== t14) {
    t15 = <div className="tab">{t10}{t14}</div>;
    $[36] = t10;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== id || $[40] !== isLogin || $[41] !== tab) {
    t16 = tab === 1 && <LawCustomInput maxLength={20} readOnly={isLogin} placeholder={"\uB2C9\uB124\uC784\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694."} title={"\uB2C9\uB124\uC784"} value={id} onChange={setId} />;
    $[39] = id;
    $[40] = isLogin;
    $[41] = tab;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== company || $[44] !== tab) {
    t17 = tab === 2 && <LawCustomInput maxLength={20} placeholder={"\uC5C5\uCCB4\uBA85\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694."} title={"\uC5C5\uCCB4\uBA85"} value={company} onChange={setCompany} />;
    $[43] = company;
    $[44] = tab;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== name) {
    t18 = <LawCustomInput maxLength={30} placeholder={"\uC774\uB984\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694."} title={"\uC774\uB984"} value={name} onChange={setName} />;
    $[46] = name;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== isLogin || $[49] !== loginModalHandler) {
    t19 = value => {
      if (!isLogin) {
        loginModalHandler();
        return;
      }
      setPhoneSelect({
        name: value,
        code: value
      });
    };
    $[48] = isLogin;
    $[49] = loginModalHandler;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <SelectTrigger className="w-[185px]"><SelectValue placeholder="010" /></SelectTrigger>;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <SelectContent>{phoneList.map(_temp2)}</SelectContent>;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== phoneSelect.code || $[54] !== t19) {
    t22 = <Select defaultValue="010" value={phoneSelect.code} onValueChange={t19}>{t20}{t21}</Select>;
    $[53] = phoneSelect.code;
    $[54] = t19;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== isLogin || $[57] !== loginModalHandler) {
    t23 = () => !isLogin && loginModalHandler();
    $[56] = isLogin;
    $[57] = loginModalHandler;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = e => {
      if (e.target.value.toString().length > 4) {
        return;
      }
      setPhone(prev => ({
        ...prev,
        fitst: e.target.value
      }));
    };
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] !== phone.fitst || $[61] !== t23) {
    t25 = <Input onClick={t23} maxLength={4} type="number" placeholder="" value={phone.fitst} onChange={t24} />;
    $[60] = phone.fitst;
    $[61] = t23;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  let t26;
  if ($[63] !== isLogin || $[64] !== loginModalHandler) {
    t26 = () => !isLogin && loginModalHandler();
    $[63] = isLogin;
    $[64] = loginModalHandler;
    $[65] = t26;
  } else {
    t26 = $[65];
  }
  let t27;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = e_0 => {
      if (e_0.target.value.toString().length > 4) {
        return;
      }
      setPhone(prev_0 => ({
        ...prev_0,
        second: e_0.target.value
      }));
    };
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  let t28;
  if ($[67] !== phone.second || $[68] !== t26) {
    t28 = <Input onClick={t26} maxLength={4} type="number" placeholder="" value={phone.second} onChange={t27} />;
    $[67] = phone.second;
    $[68] = t26;
    $[69] = t28;
  } else {
    t28 = $[69];
  }
  let t29;
  if ($[70] !== t22 || $[71] !== t25 || $[72] !== t28) {
    t29 = <LawCustomInput placeholder="" title={"\uC5F0\uB77D\uCC98"}>{t22}{t25}{t28}</LawCustomInput>;
    $[70] = t22;
    $[71] = t25;
    $[72] = t28;
    $[73] = t29;
  } else {
    t29 = $[73];
  }
  let t30;
  if ($[74] !== platform) {
    t30 = <LawCustomInput placeholder={"\uD50C\uB7AB\uD3FC\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694."} title={"\uD50C\uB7AB\uD3FC"} value={platform} maxLength={30} onChange={setPlatform} />;
    $[74] = platform;
    $[75] = t30;
  } else {
    t30 = $[75];
  }
  let t31;
  if ($[76] !== isLogin || $[77] !== loginModalHandler) {
    t31 = () => !isLogin && loginModalHandler();
    $[76] = isLogin;
    $[77] = loginModalHandler;
    $[78] = t31;
  } else {
    t31 = $[78];
  }
  let t32;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = e_1 => setDescription(e_1.target.value);
    $[79] = t32;
  } else {
    t32 = $[79];
  }
  let t33;
  if ($[80] !== description || $[81] !== t31) {
    t33 = <LawCustomInput title={"\uC0C1\uB2F4\uB0B4\uC6A9"}><Textarea onClick={t31} value={description} placeholder={"\uC0C1\uB2F4\uB0B4\uC6A9\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694."} onChange={t32} /></LawCustomInput>;
    $[80] = description;
    $[81] = t31;
    $[82] = t33;
  } else {
    t33 = $[82];
  }
  let t34;
  if ($[83] !== isLogin || $[84] !== loginModalHandler) {
    t34 = () => {
      if (!isLogin) {
        loginModalHandler();
      }
    };
    $[83] = isLogin;
    $[84] = loginModalHandler;
    $[85] = t34;
  } else {
    t34 = $[85];
  }
  let t35;
  if ($[86] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = checked => {
      setCheck(prev_1 => ({
        ...prev_1,
        Personal: checked as boolean
      }));
    };
    $[86] = t35;
  } else {
    t35 = $[86];
  }
  let t36;
  if ($[87] !== check.Personal || $[88] !== t34) {
    t36 = <Checkbox onClick={t34} checked={check.Personal} onCheckedChange={t35} />;
    $[87] = check.Personal;
    $[88] = t34;
    $[89] = t36;
  } else {
    t36 = $[89];
  }
  let t37;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <p className="text-[#fff]">개인정보 수집 및 이용동의{" "}<button className="text-[#bcbcbc] text-sm" onClick={() => window.open(isMobile ? "https://m.pandalive.co.kr/policy/service" : "/policy/service", "_blank")}>[약관동의]</button></p>;
    $[90] = t37;
  } else {
    t37 = $[90];
  }
  let t38;
  if ($[91] !== t36) {
    t38 = <label className="flex items-center gap-2">{t36}{t37}</label>;
    $[91] = t36;
    $[92] = t38;
  } else {
    t38 = $[92];
  }
  let t39;
  if ($[93] !== isLogin || $[94] !== loginModalHandler) {
    t39 = () => {
      if (!isLogin) {
        loginModalHandler();
      }
    };
    $[93] = isLogin;
    $[94] = loginModalHandler;
    $[95] = t39;
  } else {
    t39 = $[95];
  }
  let t40;
  if ($[96] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = checked_0 => {
      setCheck(prev_2 => ({
        ...prev_2,
        marketing: checked_0 as boolean
      }));
    };
    $[96] = t40;
  } else {
    t40 = $[96];
  }
  let t41;
  if ($[97] !== check.marketing || $[98] !== t39) {
    t41 = <Checkbox onClick={t39} checked={check.marketing} onCheckedChange={t40} />;
    $[97] = check.marketing;
    $[98] = t39;
    $[99] = t41;
  } else {
    t41 = $[99];
  }
  let t42;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <p className="text-[#fff]">마케팅 수신동의{" "}<button className="text-[#bcbcbc] text-sm" onClick={() => window.open(isMobile ? "https://m.pandalive.co.kr/policy/service" : "/policy/service", "_blank")}>[약관동의]</button></p>;
    $[100] = t42;
  } else {
    t42 = $[100];
  }
  let t43;
  if ($[101] !== t41) {
    t43 = <label className="flex items-center gap-2">{t41}{t42}</label>;
    $[101] = t41;
    $[102] = t43;
  } else {
    t43 = $[102];
  }
  let t44;
  if ($[103] !== t38 || $[104] !== t43) {
    t44 = <div className="check-box">{t38}{t43}</div>;
    $[103] = t38;
    $[104] = t43;
    $[105] = t44;
  } else {
    t44 = $[105];
  }
  let t45;
  if ($[106] !== isLogin || $[107] !== loginModalHandler || $[108] !== submitDisabled || $[109] !== submitHandler || $[110] !== submitMarketingDisabled || $[111] !== submitPersonalDisabled || $[112] !== validateModal) {
    t45 = <button onClick={() => {
      if (!isLogin) {
        loginModalHandler();
        return;
      }
      if (submitDisabled) {
        validateModal("\uC785\uB825\uB780\uC744 \uD655\uC778\uD574 \uC8FC\uC138\uC694.");
        return;
      }
      if (submitPersonalDisabled) {
        validateModal("\uAC1C\uC778\uC815\uBCF4 \uC218\uC9D1 \uBC0F \uC774\uC6A9\uB3D9\uC758\uB97C \uD655\uC778 \uD574 \uC8FC\uC138\uC694.");
        return;
      }
      if (submitMarketingDisabled) {
        validateModal("\uB9C8\uCF00\uD305 \uC218\uC2E0\uB3D9\uC758\uB97C \uD655\uC778 \uD574 \uC8FC\uC138\uC694.");
        return;
      }
      submitHandler();
    }}>상담하기</button>;
    $[106] = isLogin;
    $[107] = loginModalHandler;
    $[108] = submitDisabled;
    $[109] = submitHandler;
    $[110] = submitMarketingDisabled;
    $[111] = submitPersonalDisabled;
    $[112] = validateModal;
    $[113] = t45;
  } else {
    t45 = $[113];
  }
  let t46;
  if ($[114] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <p>법률상담 외의 목적으로 사용하지 않습니다.(비밀보장)</p>;
    $[114] = t46;
  } else {
    t46 = $[114];
  }
  let t47;
  if ($[115] !== t45) {
    t47 = <div className="submit-box">{t45}{t46}</div>;
    $[115] = t45;
    $[116] = t47;
  } else {
    t47 = $[116];
  }
  let t48;
  if ($[117] !== t16 || $[118] !== t17 || $[119] !== t18 || $[120] !== t29 || $[121] !== t30 || $[122] !== t33 || $[123] !== t44 || $[124] !== t47) {
    t48 = <div className="content"><div className="box">{t16}{t17}{t18}{t29}{t30}{t33}{t44}{t47}</div></div>;
    $[117] = t16;
    $[118] = t17;
    $[119] = t18;
    $[120] = t29;
    $[121] = t30;
    $[122] = t33;
    $[123] = t44;
    $[124] = t47;
    $[125] = t48;
  } else {
    t48 = $[125];
  }
  let t49;
  if ($[126] !== t15 || $[127] !== t48) {
    t49 = <div className="consult-container" id="consult">{t15}{t48}</div>;
    $[126] = t15;
    $[127] = t48;
    $[128] = t49;
  } else {
    t49 = $[128];
  }
  return t49;
}
function _temp2(code) {
  return <SelectItem key={code.code} value={code.code}>{code.name}</SelectItem>;
}
function _temp() {
  return {
    Personal: false,
    marketing: false
  };
}
export default Consult;